import {
  Box,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { commonCss } from "../../../CssStyle/commonCss";
import {
  Done,
  BalanceOutlined,
  CodeOffOutlined,
  FiberManualRecord,
  HowToVote,
  InsertChart,
  PeopleAltOutlined,
  PieChartOutline,
  TaskAlt,
  WorkspacesRounded,
} from "@mui/icons-material";
// import aboutUsBg from "../../../Images/aboutUsBg.jpg";
// import sharepoint from "../../../Images/Sharepoint/Sharepoint.jpeg";
const SharePoint = () => {
  return (
    <Grid2 container>
      <Grid2 container size={12} justifyContent={"center"}>
        <Grid2
          container
          size={12}
          sx={{ background: `url(/Images/aboutUsBg.jpg)`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            alignItems={"center"}
            mt={{ xs: "30%", sm: "20%", md: "15%", lg: "13%", xl: "8%" }}
            sx={{ p: "1rem", maxWidth: { xs: "auto", xl: "2000px" } }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                fontWeight: 600,
                lineHeight: "normal",
                mb: "1rem",
                color: commonCss.blue,
              }}
            >
              Sharepoint Cloud
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                mb: "1rem",
                textAlign: "center",
                color: commonCss.darkGray,
              }}
            >
              We provide ongoing SharePoint support to keep your platform
              running smoothly and securely. From troubleshooting and user
              assistance to performance tuning and system updates, our team is
              here to ensure your SharePoint environment stays reliable
              and user-friendly
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 11, xl: 10 }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <Box
                component={"img"}
                src={"/Images/Sharepoint/Sharepoint.jpeg"}
                alt="Sharepoint"
                sx={{
                  borderRadius: "15px",
                  width: "100%",
                  height: { xs: "50vh", md: "70vh" },
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            spacing={{ xs: "1rem", md: "2rem" }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    SharePoint On-Premise customization and development
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We provide end-to-end customization of your SharePoint
                    On-Premise environment to align with your business
                    processes, branding, and collaboration needs. From custom
                    themes to business logic and app development, we tailor the
                    platform to your organization’s exact requirements.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Services Include:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Custom site templates and layouts
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Branding and UI enhancements</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Custom content types and site columns
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Integration with third-party systems
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Feature development using SPFx, CSOM, JSOM, and REST API
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Document Management System (DMS)
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Simplify document storage, control access, and streamline
                    collaboration with a SharePoint-powered DMS. We design
                    systems that support the full lifecycle of documents while
                    ensuring compliance and traceability.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Key Capabilities:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Role-based access control</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Document approval workflows</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Version control and audit trails
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Metadata-driven navigation</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Compliance tagging and retention policies
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Project Management
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Enable your teams to manage projects with visibility,
                    structure, and collaboration using SharePoint-based
                    solutions.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Project Features:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Task and milestone tracking</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Document approval workflows</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Timeline and Gantt charts</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Resource assignment</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Project-specific document libraries
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Dashboard summaries and reports
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Library Management
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Digitize and centralize your data with powerful library
                    features that are easy to manage and access.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Library Solutions:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Department-based document libraries
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Custom metadata filtering and sorting
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Folder-level permissions</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Alerts and notifications for changes
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Retention labels and lifecycle policies
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Intranet Applications
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Build a modern, interactive intranet to keep employees
                    engaged, informed, and productive. We design user-friendly
                    portals tailored to company culture and business needs.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Popular Intranet Modules:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Company news and announcements
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Employee directories</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Departmental dashboards</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        HR request forms (leave, claims, onboarding)
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Event calendars and bulletin boards
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    SharePoint Designer Workflows
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Using SharePoint Designer, we automate repetitive processes
                    that enhance productivity and enforce business rules—without
                    custom code.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Workflow Examples:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Multi-level document approvals
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Auto-generated tasks and reminders
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        SLA tracking for support tickets
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Dynamic form routing based on conditions
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    SharePoint Web-Part Development
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We create custom web parts that extend native SharePoint
                    functionality, built with modern frameworks like SPFx,
                    React, and Angular.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Examples of Web Parts:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Real-time data dashboards</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Interactive forms and calculators
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        HR portal widgets (birthdays, recognitions)
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Integrated charts and KPI visuals
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Embedded external data feeds</ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Power Automate Development
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Automate business processes using Microsoft Power Automate,
                    seamlessly integrating SharePoint with Microsoft 365 and
                    third-party services.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Common Automations:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Document approvals and email alerts
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Data sync across SharePoint and Excel/Outlook
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Auto-archiving of old files</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Employee onboarding checklists
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Notifications from MS Forms to Teams
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Power BI Dashboards
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Visualize your SharePoint data through stunning dashboards.
                    We connect SharePoint lists, libraries, and external data
                    sources to Power BI for actionable insights.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Power BI Use Cases:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Departmental performance dashboards
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>SharePoint usage analytics</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Auto-archiving of old files</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Project progress reports</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Custom charts embedded in SharePoint pages
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    SharePoint Online Apps
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Extend SharePoint Online with business-specific apps
                    tailored to your needs. From data capture to analytics, we
                    build low-code or fully custom solutions.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Types of Apps:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Custom forms and list apps</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Employee self-service portals</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Expense tracking and leave management
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Compliance reporting</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Inventory or asset tracking systems
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    SharePoint Management
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Ensure a stable, secure, and high-performing SharePoint
                    environment through expert administration and support
                    services.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Management Services Include:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        User and permission administration
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Backup and recovery strategy</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Health monitoring and performance tuning
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Governance policy implementation
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Security audits and patch management
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    SharePoint Support Services
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We provide comprehensive SharePoint support to ensure your
                    environment remains secure, optimized, and user-friendly.
                    Our team of certified professionals is here to assist with
                    everything from technical issues to user training (Reliable,
                    responsive, and ready to help.)
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Our Support Services Include:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Ongoing maintenance & updates</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Troubleshooting and issue resolution
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>User onboarding and training</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Permissions and access management
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Workflow enhancements and automation
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Backup and disaster recovery planning
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    SharePoint Cloud Migration
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Transition your legacy systems or on-premise SharePoint to
                    SharePoint Online with minimal disruption. Our proven
                    migration strategy ensures data integrity, security, and
                    business continuity every step of the way.(Migrate with
                    confidence. Scale with purpose.)
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Our Migration Services Cover:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Pre-migration assessment and strategy
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Data cleanup and preparation</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Secure and structured content migration
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Post-migration testing and validation
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        User training and change management
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default SharePoint;
